function getColumn(row, field) {
  const non = row.Threshold ? row.Threshold[field] : null
  const serious = row.SeriousThreshold ? row.SeriousThreshold[field] : null
  const num = row[field]

  if ((num === 0 || num) && (non === 0 || non)) {
    let className = ''
    let threshold = ''
    
    if ((non == 0 && serious == 0) || num <= non) {
      className = 'text-success'
      threshold = non
    } else if (num > non && num <= serious) {
      className = 'text-warning'
      threshold = non
    } else {
      className = 'text-danger'
      threshold = serious
    }

    return `<span class="${className}">
      ${num}
    </span>(${threshold})`
  } else if ((num === 0 || num)) {
    return num
  }
}

export {getColumn}